import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import MessageTemplate, { MessageTemplateProps } from '../../templates/Message'
import { useHeaderProps } from '../../components/Header/useProps'
import Header from '../../components/Header'
import { actions, selectors } from '../../redux'
import { Screen } from '../../types/global'
import { useSagaTakeEvery } from '../../hooks/useSaga'

const MessagePage: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  // SELECTORS

  const confirmAppointement = useSelector(selectors.app.confirmAppointement)
  const appointementStep = useSelector(selectors.app.appointementStep)
  const selectedAppointementId = useSelector(selectors.app.selectedAppointementId)

  const getMe = useSelector(selectors.auth.getMe)

  const selectedAppointement = useMemo(
    () =>
      getMe.data?.appointments?.find((appointment) => appointment!.id === selectedAppointementId),
    [getMe.data?.appointments, selectedAppointementId]
  )

  const rdvUpdateMessageAppointment = useSelector(selectors.app.rdvUpdateMessageAppointment)

  // REF

  // STATE

  const [messageValue, setMessageValue] = useState(selectedAppointement?.message ?? '')

  // EFFECT

  useSagaTakeEvery(
    actions.app.confirmAppointementSuccess,
    useCallback(() => {
      dispatch(actions.app.getStoresRequest({}))
      dispatch(actions.app.setScreen({ screen: Screen.confirmation }))
    }, [dispatch])
  )

  // PROPS

  const headerProps = useHeaderProps()

  const templateProps: MessageTemplateProps = useMemo(() => {
    return {
      layoutProps: {
        header: <Header {...headerProps} />,
      },
      title: t('message.title'),
      text: t('message.text'),
      textarea: {
        name: 'message',
        label: t('message.form.message.label'),
        placeholder: t('message.form.message.placeholder'),
        value: messageValue,
        onChange: (e) => {
          setMessageValue(e.target.value)
        },
      },
      successMessage: rdvUpdateMessageAppointment.success ? t('message.success') : undefined,
      // back: {
      //   label: 'Back',
      // },
      confirmButton: {
        text: selectedAppointement ? t('message.edit') : t('message.confirm'),
        disabled: confirmAppointement.pending,
        onClick: () => {
          selectedAppointement?.id
            ? dispatch(
                actions.app.rdvUpdateMessageAppointmentRequest({
                  appointment: selectedAppointement.id,
                  message: messageValue,
                })
              )
            : dispatch(
                actions.app.confirmAppointementRequest({
                  first_name: appointementStep!.firstName,
                  last_name: appointementStep!.lastName,
                  email: appointementStep!.email,
                  slot: appointementStep!.slot,
                  message: messageValue,
                })
              )
        },
      },
    }
  }, [
    headerProps,
    t,
    messageValue,
    rdvUpdateMessageAppointment.success,
    selectedAppointement,
    confirmAppointement.pending,
    dispatch,
    appointementStep,
  ])

  // RETURN

  return <MessageTemplate {...templateProps} />
}

export default MessagePage
